import { useState, useMemo, useCallback } from 'react';

interface UsePanoptoIframe {
  isLoading: boolean;
  isLoaded: boolean;
  startLoading: () => void;
  onLoad: () => void;
  reset: () => void;
}

const useIframe = (deps: any[] = []): UsePanoptoIframe => {
  const [isLoaded, setLoaded] = useState(false);
  const [isLoading, setLoading] = useState(false);

  const startLoading = useCallback(() => {
    setLoaded(false);
    setLoading(true);
  }, []);

  const reset = useCallback(() => {
    setLoaded(false);
    setLoading(false);
  }, []);

  const onLoad = useCallback(() => {
    if (isLoading && (!deps.length || deps.every((dep) => Boolean(dep)))) {
      setLoading(false);
      setLoaded(true);
    }
  }, [isLoading, ...deps]);

  return useMemo(() => ({ isLoaded, isLoading, startLoading, onLoad, reset }), [isLoading, isLoaded, onLoad]);
};

export default useIframe;
